module.exports = __webpack_public_path__ + "img/10.bbd9fb89.jpg";